var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"mb-5"},[_vm._v("\n      Marketing\n    ")]),_c('nav-marketing',{attrs:{"tab":"facebook"}}),_c('facebook-catalog')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }